import { render, staticRenderFns } from "./ProductSelectionContainer.vue?vue&type=template&id=a535485a&scoped=true&"
import script from "./ProductSelectionContainer.vue?vue&type=script&lang=ts&"
export * from "./ProductSelectionContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a535485a",
  null
  
)

export default component.exports